import React, { useEffect, useState } from "react";
import { useAuthentication } from "../../contexts/AuthenticationContext";
import type { UserProfileDetails } from "../../services/brainflex/UsersServiceClient";

const Auth: React.FC = () => {
  // State
  const [message, setMessage] = useState("Processing login...");
  const [profile] = useState<UserProfileDetails>();

  // Context
  const { isLoggedIn, user, login } = useAuthentication();

  useEffect(() => {
    if (!isLoggedIn) {
      setMessage("You are not logged in.");
      // Optionally, trigger login automatically:
      // login();
    } else {
      setMessage("You are logged in.");
      // Optionally, fetch user profile here using user info
      // setProfile(...)
    }
  }, [isLoggedIn, user, login]);

  return (
    <>
      <h1>Auth</h1>
      <div>
        <h2>{message}</h2>
        {user && (
          <pre>{JSON.stringify(user, null, 2)}</pre>
        )}
        {profile && (
          <pre>{JSON.stringify(profile, null, 2)}</pre>
        )}
        {!isLoggedIn && (
          <button onClick={login}>Log in</button>
        )}
      </div>
    </>
  );
};

export default Auth;